// The site's styles load before any component's.
import './styles';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { arriveInStudio } from './features/account/arrival';
import { loadPreferredLocale } from './i18n/catalogs';
import { retireServiceWorker } from './retire-service-worker';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

void retireServiceWorker();
arriveInStudio();

// Load the language first, so the page never flashes another.
void loadPreferredLocale().then((i18n) => {
  createRoot(root).render(
    <StrictMode>
      <App i18n={i18n} />
    </StrictMode>,
  );
});
